import { Statistics } from '@/models/statistics.model';
import { BaseService } from './base.service';

export class StatisticsService extends BaseService {
  private url: string = '/api/statistics';

  constructor() {
    super();
  }

  async getQuizzesStartedFinished(): Promise<Statistics[]> {
    const res = await this.$http.get<Statistics[]>(
      `${this.url}/quizzes-started-finished`,
    );

    return res.data;
  }

  async getQuizzesPerDay(): Promise<Statistics[]> {
    const res = await this.$http.get<Statistics[]>(`${this.url}/quizzes-daily`);

    return res.data;
  }

  async actionsAddedPerDay(): Promise<Statistics[]> {
    const res = await this.$http.get<Statistics[]>(`${this.url}/actions-added`);

    return res.data;
  }

  async actionsDonePerDay() {
    const res = await this.$http.get<Statistics[]>(`${this.url}/actions-done`);

    return res.data;
  }

  async userCo2Footprints(): Promise<Statistics[]> {
    const res = await this.$http.get<Statistics[]>(`${this.url}/user-co2`);

    return res.data;
  }

  async usersPerDay(): Promise<Statistics[]> {
    const res = await this.$http.get<Statistics[]>(`${this.url}/users-per-day`);

    return res.data;
  }

  async userInterests(): Promise<Statistics[]> {
    const res = await this.$http.get<Statistics[]>(
      `${this.url}/user-interests`,
    );

    return res.data;
  }

  async userMotivation(): Promise<Statistics[]> {
    const res = await this.$http.get<Statistics[]>(
      `${this.url}/user-motivation`,
    );

    return res.data;
  }
}

export default new StatisticsService();
